// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DetailsItem_wrapper__1tRz2","itemTitle":"DetailsItem_itemTitle__2iT4G","itemText":"DetailsItem_itemText__1kd1K"};